module.exports = __webpack_public_path__ + "media/images/application/template/windpost-9eda4e25ebe6239b2f3e6c7f024f3e95.png";